export default __webpack_public_path__ + "assets/images/a6e81fff0cc05adf3a7aa8305fa9f3d9.png";